import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nida-web-patient-board',
  templateUrl: './patient-board.component.html',
  styleUrls: ['./patient-board.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class PatientBoardComponent {}
